window.isBantoaLoaded = false;

// qui attacchiamo il tracker di Bantoa che serve purtroppo per tutto il resto
class Bantoa {
  static EVENTS = {
    LOADED: "bantoa_loaded",
  }

  init = () => {
    if(!window.bantoaKey) {
      console.error("Bantoa: API key not found. Please set the bantoaKey variable before initializing.");
      return;
    }
    const self = this;
    !function(t,n,e,a,c,o,r,s){t.BantoaTrackerObject=c,t[c]=t[c]||function(){(t[c].q=t[c].q||[]).push(arguments)},
    t[o]=t[o]||function(){(t[o].q=t[o].q||[]).push(arguments)},
    r=n.createElement(e),s=n.getElementsByTagName(e)[0],r.async=1, r.onload=self.started, r.src=a,s.parentNode.insertBefore(r,s)}
    (window,document,"script",`https://www.bantoa.com/bantoa.tk.min.js?apikey=${window.bantoaKey}`,"bnt_t","bnt_r_ai");

    bnt_t('create', Shopify.locale, {
      consent: 1,
      country: Shopify.country
    });
  }

  started = () => {
    window.isBantoaLoaded = true;
    window.dispatchEvent(new CustomEvent(Bantoa.EVENTS.LOADED));
  }
}

// questo gestisce il visual search, in pratica al click sul componente ti fa caricare immagine e poi fa partire il visual search con l'immagine caricata (base64)
// Web Component: BantoaSearch
// Permette di avviare la ricerca visuale tramite click o parametro URL
class BantoaSearch extends HTMLElement {

  connectedCallback() {
    if(!this.dataset.position){
      console.error("BantoaSearch: No position found in the element.");
      return;
    }
    if(window.isBantoaLoaded)
      this.init();
    window.addEventListener(Bantoa.EVENTS.LOADED, this.init.bind(this));
  }

  init = () => {
    this.classList.add('mc-active'); // Rende il componente visibile solo dopo l'inizializzazione
    this.addEventListener('click', this.openViewer.bind(this));
    const url = new URL(window.location.href);
    if(url.searchParams.has("bantoa")){
      this.openViewer(this);
    }
  }

  addParameterToUrl(){
    const url = new URL(window.location.href);
    url.searchParams.append("bantoa", "bantoa");
    window.history.pushState({}, '', url)
  }

  openViewer = (base64Img) => {
    if(!window.isBantoaLoaded) {
      console.error("BantoaSearch: Bantoa tracker is not loaded.");
      window.addEventListener(Bantoa.EVENTS.LOADED, () => this.openViewer(base64Img));
      return;
    }
    bnt_r_ai('visual', 'modal', {
	    quality: '0.75',
	    max_results: 100,
	    min_results: 1,
	    position: this.dataset.position,
	  });
    const url = new URL(window.location.href);
    if(!url.searchParams.has("bantoa")){
      this.addParameterToUrl();
    }
  }
}
customElements.define("bantoa-search", BantoaSearch);

class BantoaProductSearch extends HTMLElement {

  connectedCallback() {
    if(!this.dataset.sku) {
      console.error("BantoaProductSearch: No SKU found in the element.");
      return;
    }
    if(!this.dataset.position){
      console.error("BantoaProductSearch: No position found in the element.");
      return;
    }
    if(window.isBantoaLoaded)
      this.init();
    window.addEventListener(Bantoa.EVENTS.LOADED, this.init.bind(this));
  }

  checkExists = () => {
    fetch(`https://api.bantoa.com/api/visual?apikey=${window.bantoaKey}&onlycheckexist=1&code=${this.dataset.sku}&tm=1751548151`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
    .then(data => {
      if(data.productexist == 'ok'){
        this.classList.add('mc-active'); // Rende il componente visibile solo dopo l'inizializzazione
      }
    })
    .catch(e => {
      console.error("BantoaProductSearch: Error checking product existence", e);
    });
  }

  init = () => {
    this.checkExists();
    this.addEventListener('click', this.openViewer.bind(this));
  }

  openViewer = (e) => {
    if(e) {
      e.stopPropagation(); // Impedisce la propagazione del click se l'evento è stato passato
      e.stopImmediatePropagation(); // Impedisce altri handler
      e.preventDefault(); // Blocca il comportamento predefinito
    }
    if(!window.isBantoaLoaded) {
      console.error("BantoaProductSearch: Bantoa tracker is not loaded.");
      return;
    }
    const data = {
	    item: this.dataset.sku,
	    quality: '0.75',
	    max_results: 100,
	    min_results: 1,
	    position: this.dataset.position,
      shopTheLook: false,
      customSorting: 'glamood'
    };
    if(this.dataset.variant){
      data.filter = {
        sizes: this.dataset.variant
      };
    }
    bnt_r_ai('visual', 'modal', data);
  }
}
customElements.define("bantoa-product-search", BantoaProductSearch);

class BantoaCarousel extends HTMLElement {
  #config;
  #template;
  #products;
  #cards;

  connectedCallback() {
    setTimeout(() => {
      const script = this.querySelector('script[data-config]');
      if(!script) {
        console.error("BantoaList: No configuration script found.");
        return;
      }
      this.#config = JSON.parse(script.textContent);
      console.log("BantoaList: Configuration loaded", this.#config);

      this.#template = this.querySelector('template');
      if(!this.#template) {
        console.error("BantoaList: No template found for products.");
        return;
      }

      window.addEventListener(Bantoa.EVENTS.LOADED, this.init.bind(this));
      if(window.isBantoaLoaded)
        this.init();
    });
  }

  init = () => {
    if(!window.isBantoaLoaded) {
      console.error("BantoaList: Bantoa tracker is not loaded.");
      return;
    }
    bnt_r_ai(this.#config.type, this.#config.src, this.#config.options).then(data => {
      console.log("BantoaList: Data received", data);
      this.#products = data.data?.products || [];
      this.getCards();
    }).catch(err => {
      console.error('Visual-data promise failed:', err);
    });
  } 
  
  getCards = () => {
    console.log('BANTOA: Fetching products from list: ', this.#products);
    Promise.all(this.#products.map(product => {
      const url = new URL(product.directurl);
      url.searchParams.append('section_id', 'helper-card');
      return axios.get(url.toString())
      .then(resp => {
        console.log('BANTOA RESPONSE: ', resp)
        return resp.data})
    })).then(htmlList => {
      console.log("BantoaList: Product HTML received", htmlList);
      this.#cards = htmlList.map((html, i) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        doc.querySelectorAll('a').forEach(a => {
          if(a.href.includes(`products/`)){
            a.href = this.#products[i].trackingurl || a.href;
          }
        });
        return doc.body.innerHTML;
      });
      this.render();
    })
  }

  render = () => {
    const html = this.#template.innerHTML;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const wrapper = doc.querySelector('[data-products]');
    if(!wrapper) {
      console.error('BantoaList: No wrapper found for products');
      return;
    }
    wrapper.innerHTML = this.#cards.join('');
    this.innerHTML = doc.body.innerHTML;
  }

  getTrackingProduct = (product) => {
    const p = this.bantoaProducts.find((prod) => prod.sku == product.metaGroupCode.value);
    product.trackingUrl = p?.trackingurl;
    product.sku = p?.sku || product.sku;
    return product;
  }
}
customElements.define("bantoa-carousel", BantoaCarousel);